import {useState} from 'react';
import type {Vehicle} from '../types';
const prefix='precisionEV.activeVehicle.v1:';
function read(scope:string){try{return localStorage.getItem(prefix+scope)||'';}catch{return '';}}
// Browsing a vehicle is a device preference, not a mutation of its workshop record.
// Account and demo scopes prevent another session's selection from leaking across users.
export function useActiveVehicle(vehicles:Vehicle[],scope:string){
 const [choice,setChoice]=useState(()=>({scope,id:read(scope)}));
 const chosen=choice.scope===scope?choice.id:read(scope);
 const vehicle=vehicles.find(v=>v.id===chosen)||vehicles.find(v=>v.primary)||vehicles[0];
 function select(id:string){if(!vehicles.some(v=>v.id===id))return;setChoice({scope,id});try{localStorage.setItem(prefix+scope,id);}catch{/* Still works for this session. */}}
 return {vehicle,select};
}
